export const blogs = [
  {
    title: "Blood Donation Camp - 2025",
    subtitle: "Blood donation camp held on the occasion of Ramakrishna Mane's birthday; 51 blood donors participated",
    link: 'https://primenewssolapur.blogspot.com/2025/09/blog-post_3.html',
    year: 2025,
  },
  {
    title: "निराधारांचा आधार",
    subtitle: "संस्थापक/अध्यक्ष - भटके विमुक्त जाती व जमाती आदिवासी ज्ञानपीठ",
    link: 'https://saptahik-sandesh.com/general-news/basis/',
    priority: "high"
  },
  {
    title: "Independence Day Celebration - 2025",
    subtitle: "एकलव्य आश्रमशाळेत स्वातंत्र्य दिन उत्साहात साजरा",
    link: 'https://khabarmarathi.wordpress.com/2025/08/15/karmala-eklavya-school-news/',
    year: 2025
  },
  {
    title: "Song by our Student",
    subtitle: "चिमुकली ने गायलेले गाणे - मुल्क मेरा देश",
    link: 'https://youtube.com/shorts/-x9dGcxpFws?si=gsZFZdfkLeNsXJ6I',
    year: 2025
  },
  {
    title: "एकलव्य आश्रमशाळा स्नेहसंमेलन - 2025",
    subtitle: "एकलव्य आश्रमशाळेचे स्नेहसंमेलन उत्साहात; विद्यार्थ्यांच्या कलागुणांचे प्रेक्षकांकडून कौतुक",
    link: 'https://saptahikpawanputra.com/?p=17991',
    year: 2025
  },
  {
    title: "Republic Day Celebration - 2025",
    subtitle: "एकलव्य आश्रमशाळेत प्रजासत्ताक दिन उत्साहात साजरा",
    link: 'https://sangharshnewssolapur.blogspot.com/2025/01/blog-post_42.html?m=1',
    year: 2025
  },
  {
    title: "Donation - Blanket",
    subtitle: "करमाळा येथील एकलव्य आश्रमशाळेतील विद्यार्थ्यांना ब्लॅंकेट वाटप",
    link: 'https://sangharshnews1.blogspot.com/2024/11/blog-post_27.html?m=1',
    year: 2024
  },
  {
    title: "शिक्षकांचा सुसंस्कृत पिढीसाठी योगदान",
    subtitle: "पोलीस निरीक्षक श्री. घुगे यांचे मार्गदर्शन; एकलव्य आश्रमशाळेत गुणवंत विद्यार्थ्यांचा सत्कार",
    link: 'https://saptahik-sandesh.com/general-news/contribution-of-teachers-for-cultured-generation-important-police-inspector-mr-ghuge-eklavya-ashramshala-honor-meritorious/',
    year: 2024
  },
  {
    "title": "गावडे यांच्याकडून वाढदिवसानिमित्त आश्रमशाळेत गोडजेवण",
    "subtitle": "जेजुरीच्या अमृता गावडे यांच्या वाढदिवसानिमित्त, गावडे परिवारानं अनावश्यक खर्च टाळून एकलव्य आश्रमशाळेत वाढदिवस साजरा केला.",
    "link": "https://eklavyakarmala1.wordpress.com/2024/08/14/karmala-gavde-aashrmshala-jevn/",
    "year": 2024
  },
  {
    "title": "वीटच्या जाधव परिवारानं आश्रमशाळेतील मुलांसोबत साजरा केला अद्विकचा वाढदिवस",
    "subtitle": "गजेंद्र आणि वंदना जाधव यांनी मुलगा अद्विकचा दुसरा वाढदिवस एकलव्य प्राथमिक आश्रमशाळेत मुलांसोबत साजरा केला आणि खाऊ, पावभाजीचे आयोजन केले.",
    "link": "https://eklavyakarmala1.wordpress.com/2024/08/11/karmala-jadhav-aashrmshala-news/",
    "year": 2024
  },
  {
    "title": "बालाजी चांदगुडे यांच्याकडून आश्रमशाळेत गोडजेवण",
    "subtitle": "करमाळ्याचे युवा उद्योजक बालाजी चांदगुडे यांच्या वाढदिवसानिमित्त एकलव्य प्राथमिक आश्रमशाळेत विद्यार्थ्यांना गोडजेवण देण्यात आले.",
    "link": "https://eklavyakarmala1.wordpress.com/2024/07/15/karmala-balaji-chandgude-news/",
    "year": 2024
  },
  {
    "title": "वाढदिवसानिमित्त सरडे यांच्याकडून आश्रमशाळेत गोडजेवण",
    "subtitle": "वांगी चारचे किरण सरडे कुटुंबीयांनी कार्तिकच्या पहिल्या वाढदिवसानिमित्त एकलव्य प्राथमिक आश्रमशाळेत विद्यार्थ्यांना गोडजेवण दिले.",
    "link": "https://eklavyakarmala1.wordpress.com/2024/06/30/karmala-aashramshala-godjevan-sarade-news/",
    "year": 2024
  },
  {
    "title": "Donation - Notebook",
    "subtitle": "माही डेकोरेशनचे मंगेश गोडसे यांच्या वाढदिवसानिमित्त त्यांच्या वतीने एकलव्य आश्रमशाळेत विद्यार्थ्यांना १० डझन वह्यांचे वाटप करण्यात आले.",
    "link": "https://eklavyakarmala1.wordpress.com/2024/06/28/karmala-mangesh-godase-vadhadivas-vatap/",
    "year": 2024
  },
  {
    "title": "ओंकार चांदगुडे यांच्या वाढदिवसानिमित्त एकलव्य आश्रमशाळेत मिष्टान्न भोजन",
    "subtitle": "करमाळ्याचे युवा उद्योजक ओंकार चांदगुडे यांच्या वाढदिवसानिमित्त एकलव्य प्राथमिक आश्रमशाळेत विद्यार्थ्यांना मिष्टान्न भोजन देण्यात आले.",
    "link": "https://eklavyakarmala1.wordpress.com/2024/04/02/onkar-chandgude-karmala-birthday-news/",
    "year": 2024
  },
  {
    "title": "अभिषेक आव्हाड, अजिंक्य पाटील वाढदिवस - एकलव्य आश्रमशाळेत मिष्टान्न भोजन",
    "subtitle": "राष्ट्रवादी काँग्रेसचे युवा नेते अभिषेक आव्हाड, अजिंक्य पाटील यांच्या वाढदिवसानिमित्त एकलव्य प्राथमिक आश्रमशाळेत विद्यार्थ्यांना मिष्टान्न भोजन देण्यात आले. कार्यक्रमात अनेक मान्यवर उपस्थित होते.",
    "link": "https://eklavyakarmala1.wordpress.com/2024/04/01/karmala-avhad-aashrmshala-news/",
    "year": 2024
  },
  {
    "title": "आकाश सिंधी यांच्या वाढदिवसानिमित्त आश्रमशाळा येथे विद्यार्थ्यांना स्नेहभोजन",
    "subtitle": "प्रसिद्ध युवा उद्योजक आकाश सिंधी यांच्या वाढदिवसानिमित्त एकलव्य प्राथमिक आश्रमशाळेत विद्यार्थ्यांना स्नेहभोजन व सत्काराचा कार्यक्रम आयोजित करण्यात आला.",
    "link": "https://eklavyakarmala1.wordpress.com/2024/03/19/karmala-akaah-sindhi-vadhdivas/",
    "year": 2024
  },
  {
    "title": "करमाळ्यातील सुनीलबापू सावंत यांचा वाढदिवस – आश्रमशाळेत विद्यार्थ्यांना स्नेहभोजन",
    "subtitle": "सामाजिक कार्यकर्ते सुनील (बापू) सावंत यांच्या वाढदिवसानिमित्त एकलव्य प्राथमिक आश्रमशाळेत विद्यार्थ्यांना स्नेहभोजन देण्यात आले. या कार्यक्रमाचे आयोजन चांदगुडे परिवाराच्या वतीने करण्यात आले.",
    "link": "https://eklavyakarmala1.wordpress.com/2024/03/12/karnala-sawant-chandgude-news/",
    "year": 2024
  },
  {
    "title": "कुशल जैन यांचा वाढदिवस – एकलव्य आश्रमशाळेत शैक्षणिक साहित्य व खाऊ वाटप",
    "subtitle": "कुशल जैन यांच्या वाढदिवसानिमित्त त्यांच्या मित्र परिवाराच्या वतीने करमाळ्याच्या एकलव्य प्राथमिक आश्रमशाळेत विद्यार्थ्यांना खाऊ तसेच वही, पेन यांसारख्या शैक्षणिक साहित्याचे वाटप करण्यात आले.",
    "link": "https://eklavyakarmala1.wordpress.com/2024/03/12/karmala-vadhadivas-kushal-jain/",
    "year": 2024
  },
];
